module.exports = __webpack_public_path__ + "img/ckgd.fc6766cf.png";